import { render, staticRenderFns } from "./BestDuration.vue?vue&type=template&id=43221db3"
import script from "./BestDuration.vue?vue&type=script&lang=js"
export * from "./BestDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports